export const SET_TEMPLATE_TYPE = 'SET_TEMPLATE_TYPE';
export const SET_JOURNAL_INITIAL_STATE = 'SET_JOURNAL_INITIAL_STATE';
export const FETCH_INITIAL_STATE_FAILED = 'FETCH_INITIAL_STATE_FAILED';
export const CHANGE_BASIC_INPUT = 'CHANGE_BASIC_INPUT';
export const CHANGE_PARAGRAPH_COMPONENT_INPUT =
  'CHANGE_PARAGRAPH_COMPONENT_INPUT';
export const CHANGE_PERSON_INPUT = 'CHANGE_PERSON_INPUT';
export const CHANGE_AFFILIATION_INPUT = 'CHANGE_AFFILIATION_INPUT';
export const UPDATE_AFFILIATIONS_AUTHORS = 'UPDATE_AFFILIATIONS_AUTHORS';
export const CHANGE_BASICARRAYINPUT_INPUT = 'CHANGE_BASICARRAYINPUT_INPUT';
export const CHANGE_SLATE_EDITORS_VALUE = 'CHANGE_SLATE_EDITORS_VALUE';
export const CHANGE_REFERENCE_INPUT = 'CHANGE_REFERENCE_INPUT';
export const CHANGE_DATE_INPUT = 'CHANGE_DATE_INPUT';
export const ADD_PERSON = 'ADD_PERSON';
export const ADD_AFFILIATION = 'ADD_AFFILIATION';
export const ADD_BASICARRAYINPUT = 'ADD_BASICARRAYINPUT';
export const ADD_REFERENCE = 'ADD_REFERENCE';
export const REMOVE_PERSON = 'REMOVE_PERSON';
export const REMOVE_AFFILIATION = 'REMOVE_AFFILIATION';
export const REMOVE_BASICARRAYINPUT = 'REMOVE_BASICARRAYINPUT';
export const REMOVE_REFERENCE = 'REMOVE_REFERENCE';
export const UPDATE_REFERENCES = 'UPDATE_REFERENCES';
export const UPDATE_ADD_REFERENCE_FOCUS_REFERENCES =
  'UPDATE_ADD_REFERENCE_FOCUS_REFERENCES';
export const CHANGE_DOCUMENT_EDITED_STATUS = 'CHANGE_DOCUMENT_EDITED_STATUS';
export const CHANGE_HISTORY_BACKWARD = 'CHANGE_HISTORY_BACKWARD';
export const CHANGE_HISTORY_FORWARD = 'CHANGE_HISTORY_FORWARD';
export const CHANGE_EDIT_DOCUMENT_REDUCER_ON_UNMOUNT =
  'CHANGE_EDIT_DOCUMENT_REDUCER_ON_UNMOUNT';
export const ADD_NEW_OBJECT_TO_ARRAY = 'ADD_NEW_OBJECT_TO_ARRAY';
export const SAVE_DATA = 'SAVE_DATA';
export const SET_COUNTER_VALUE = 'SET_COUNTER_VALUE';
export const SET_UNMOUNT_DATA = 'SET_UNMOUNT_DATA_JOURNAL';
export const UPDATE_USER_PREFERENCES = 'UPDATE_USER_PREFERENCES_JOURNAL';
export const UPDATE_HISTORY = 'UPDATE_HISTORY';
export const UPDATE_DOCUMENT_NAME = 'UPDATE_DOCUMENT_NAME';
